import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import { Alert, Table, Button, Row, Col } from 'reactstrap';
import ConfirmDialog from '../Components/ConfirmDialog';
import { GetAllRates, DeleteRateMutation } from './query';
import CreateRateForm from './createRate';

class Rates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showerror: '',
      showerrortype: 'danger',
      showdialog: false,
      rates: null,
      message: '',
      title: '',
      newrate: [],
      tableindex: '',
    };
  }

  addNewRate = newrate => {
    this.setState({
      newrate: [newrate, ...this.state.newrate],
    });
  };
  toggle = () => {
    this.setState({
      showdialog: !this.state.showdialog,
    });
  };
  handleDelete = (rate, index) => {
    this.setState({
      rates: rate,
      message: `Are you sure you want to delete this rate: ${rate.rate}`,
      title: `Delete rate for: ${rate.name}`,
      tableindex: index,
    });
    this.toggle();
  };
  handleClick = async () => {
    // console.table(this.state.rates);
    // force reload after the deletions
    try {
      await this.props.deleterate({
        variables: {
          id: this.state.rates.id,
        },
        update: (proxy, { data: { deleterate } }) => {
          const data = proxy.readQuery({ query: GetAllRates });

          const newdata = data.rates.filter(
            rt => rt.id !== this.state.rates.id
          );

          this.setState({
            showerrortype: deleterate.success ? 'success' : 'danger',
            showerror: deleterate.message,
            newrate: [],
          });
          proxy.writeQuery({ query: GetAllRates, data: newdata });
        },
      });
    } catch (error) {
      this.setState({
        showerror: error.message,
        showerrortype: 'danger',
      });
    }
    // this.toggle();
  };

  render() {
    const { rates: { loading, error, rates } } = this.props;
    if (loading) {
      return <div>Loading.....</div>;
    }
    if (error) {
      return <Alert color="danger">Error occurred while loading</Alert>;
    }
    const mrates = [...this.state.newrate, ...rates];
    return (
      <div>
        <Row>
          <Col xs="7">
            <h2>Rates</h2>
            {this.state.showerror && (
              <Alert color={this.state.showerrortype}>
                {this.state.showerror}
              </Alert>
            )}
            <Table>
              <thead>
                <tr>
                  <th> ID</th>
                  <th> Name</th>
                  <th> Rate</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {mrates.map((rate, index) => (
                  <tr key={rate.id}>
                    <td>{rate.id}</td>
                    <td>{rate.name}</td>
                    <td>{rate.rate}</td>
                    <td style={{ width: '100px' }}>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => this.handleDelete(rate, index)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {this.state.showdialog && (
              <ConfirmDialog
                title={this.state.title}
                message={this.state.message}
                onClick={() => this.handleClick()}
                onClose={() => this.toggle()}
              />
            )}
          </Col>
          <Col xs="1">&nbsp;</Col>
          <Col xs="4">
            <h2>Create New Rate</h2>
            <br />
            <CreateRateForm onNewRate={this.addNewRate} />
          </Col>
        </Row>
      </div>
    );
  }
}

const QueryAllRates = compose(
  graphql(GetAllRates, { name: 'rates' }),
  graphql(DeleteRateMutation, { name: 'deleterate' })
);

export default QueryAllRates(Rates);



// WEBPACK FOOTER //
// ./src/views/Rates/index.js